import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AccessorialCard from 'components/modules/tools/AccessorialCard';

export default function AccessorialGrid({ accessorials, handleSelect }) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-wrap -mx-2">
      {accessorials.map((acc) => (
        <AccessorialCard
          key={acc.value}
          name={t(acc.localizeDescription)}
          className="px-2 mb-4"
          selected={acc.selected}
          iconSlug={acc.icon_slug}
          onSelect={() => handleSelect(acc.value)}
          canSelect
        />
      ))}
    </div>
  );
}

AccessorialGrid.propTypes = {
  accessorials: PropTypes.array.isRequired,
  handleSelect: PropTypes.func.isRequired,
};
